import { render } from "./IsoBookingButtonForm.vue?vue&type=template&id=35efa228"
import script from "./IsoBookingButtonForm.vue?vue&type=script&lang=js"
export * from "./IsoBookingButtonForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__